export default "__VITE_ASSET__Cp_gj8SK__"